import { Box, Chip, Typography } from '@mui/material';
import type { ChipProps } from '@mui/material/Chip';
import { PURCHASE_ORDER_STATES } from 'lib/consts';
import React from 'react';

export interface POHeaderProps {
  name?: string | null;
  externalCode: string;
  statusCode: number;
}

const POHeader: React.FC<POHeaderProps> = ({
  name,
  externalCode,
  statusCode,
}) => {
  const statusDef = PURCHASE_ORDER_STATES.find(
    (s) => String(s.value) === String(statusCode),
  );
  const chipColor: ChipProps['color'] =
    (statusDef?.color as ChipProps['color']) ?? 'default';

  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography
        variant="h6"
        sx={{
          mb: 0.25,
          fontWeight: 700,
          color: 'text.primary',
          lineHeight: 1.1,
        }}
      >
        {name || 'Orden de compra'}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          mb: 0.75,
          flexWrap: 'wrap',
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: '0.75rem' }}
        >
          Código: {externalCode}
        </Typography>
        <Chip
          label={statusDef?.label ?? 'Otro'}
          color={chipColor}
          size="small"
          sx={{ height: '18px', fontSize: '0.6rem' }}
        />
      </Box>
    </Box>
  );
};

export default POHeader;
